import { SORT_DIRECTION, FILTER_KEYS } from 'store/browse-items/fixtures';
import {
  SORT_DIRECTION as BARCODE_SORT_DIRECTION,
  FILTER_KEYS as BARCODE_FILTER_KEYS,
} from 'store/barcode-items/fixtures';

export const SORTING = {
  RECENT: 'RECENT',
  OLDEST: 'OLDEST',
  MOST_LIKED: 'MOST_LIKED',
  NAME: 'NAME',
  CATEGORY: 'CATEGORY',
  MANUFACTURER: 'MANUFACTURER',
  STORAGE: 'STORAGE',
};

export const DEFAULT_SORTING_OPTIONS = [
  { text: 'Most recent', value: SORTING.RECENT },
  { text: 'Oldest', value: SORTING.OLDEST },
];

export const SET_SORTING_OPTIONS = [
  ...DEFAULT_SORTING_OPTIONS,
  { text: 'Name', value: SORTING.NAME },
];

export const ITEM_SORTING_OPTIONS = [
  ...SET_SORTING_OPTIONS,
  { text: 'Most liked', value: SORTING.MOST_LIKED },
  { text: 'Category', value: SORTING.CATEGORY },
  { text: 'Manufacturer', value: SORTING.MANUFACTURER },
  { text: 'Storage', value: SORTING.STORAGE },
];

export const BARCODE_SORTING_OPTIONS = [
  { text: 'Name', value: BARCODE_SORT_DIRECTION.NAME },
  { text: 'Most recent', value: BARCODE_SORT_DIRECTION.DESC },
  { text: 'Category', value: BARCODE_SORT_DIRECTION.CATEGORY },
  { text: 'Manufacturer', value: BARCODE_SORT_DIRECTION.MANUFACTURER },
];

export const BARCODE_SORTING_VALUES = {
  [BARCODE_SORT_DIRECTION.NAME]: {
    // [FILTER_KEYS.SORT_BY]: API_FIELDS.CREATED_AT,
    [BARCODE_FILTER_KEYS.SORT_DIRECTION]: SORTING.NAME,
  },
  [SORTING.RECENT]: {
    // [FILTER_KEYS.SORT_BY]: API_FIELDS.CREATED_AT,
    [BARCODE_FILTER_KEYS.SORT_DIRECTION]: BARCODE_SORT_DIRECTION.DESC,
  },
  // [SORTING.OLDEST]: {
  //   // [FILTER_KEYS.SORT_BY]: API_FIELDS.CREATED_AT,
  //   [FILTER_KEYS.SORT_DIRECTION]: SORT_DIRECTION.ASC,
  // },
  // [SORTING.MOST_LIKED]: {
  //   // [FILTER_KEYS.SORT_BY]: API_FIELDS.CREATED_AT,
  //   [FILTER_KEYS.SORT_DIRECTION]: SORT_DIRECTION.MOST_LIKED,
  // },

  [SORTING.CATEGORY]: {
    // [FILTER_KEYS.SORT_BY]: API_FIELDS.CREATED_AT,
    [BARCODE_FILTER_KEYS.SORT_DIRECTION]: BARCODE_SORT_DIRECTION.CATEGORY,
  },
  [SORTING.MANUFACTURER]: {
    // [FILTER_KEYS.SORT_BY]: API_FIELDS.CREATED_AT,
    [BARCODE_FILTER_KEYS.SORT_DIRECTION]: BARCODE_SORT_DIRECTION.MANUFACTURER,
  },
};

export const SORTING_VALUES = {
  [SORTING.RECENT]: {
    // [FILTER_KEYS.SORT_BY]: API_FIELDS.CREATED_AT,
    [FILTER_KEYS.SORT_DIRECTION]: SORT_DIRECTION.DESC,
  },
  [SORTING.OLDEST]: {
    // [FILTER_KEYS.SORT_BY]: API_FIELDS.CREATED_AT,
    [FILTER_KEYS.SORT_DIRECTION]: SORT_DIRECTION.ASC,
  },
  [SORTING.MOST_LIKED]: {
    // [FILTER_KEYS.SORT_BY]: API_FIELDS.CREATED_AT,
    [FILTER_KEYS.SORT_DIRECTION]: SORT_DIRECTION.MOST_LIKED,
  },
  [SORTING.NAME]: {
    // [FILTER_KEYS.SORT_BY]: API_FIELDS.CREATED_AT,
    [FILTER_KEYS.SORT_DIRECTION]: SORT_DIRECTION.NAME,
  },
  [SORTING.CATEGORY]: {
    // [FILTER_KEYS.SORT_BY]: API_FIELDS.CREATED_AT,
    [FILTER_KEYS.SORT_DIRECTION]: SORT_DIRECTION.CATEGORY,
  },
  [SORTING.MANUFACTURER]: {
    // [FILTER_KEYS.SORT_BY]: API_FIELDS.CREATED_AT,
    [FILTER_KEYS.SORT_DIRECTION]: SORT_DIRECTION.MANUFACTURER,
  },
  [SORTING.STORAGE]: {
    // [FILTER_KEYS.SORT_BY]: API_FIELDS.CREATED_AT,
    [FILTER_KEYS.SORT_DIRECTION]: SORT_DIRECTION.STORAGE,
  },
};
